import { render } from "./ContentPanel.vue?vue&type=template&id=4d9d37da&scoped=true"
import script from "./ContentPanel.vue?vue&type=script&lang=js"
export * from "./ContentPanel.vue?vue&type=script&lang=js"

import "./ContentPanel.vue?vue&type=style&index=0&id=4d9d37da&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9d37da"]])

export default __exports__